import styles from "./ViewPhoneRestriction.module.css";
import LabeledInfo from "../../common/LabeledInfo";
import { formatInCentralTime } from "../../../lib/formatting";
import Tooltip from "../../common/Tooltip";
import { GetPhoneOptionsResponse, PhoneContact } from "../../../lib/api/models";
import classNames from "classnames";

const strings = {
  restrictedUseYes: "Restricted Use: Yes",
  restrictedUseNo: "Restricted Use: No",
  tooltipText:
    "A number is set to restricted use when requested that we only call specific numbers on specific days or with specific instructions. Restricted Use only impacts active numbers, as inactive numbers are not loaded in the dialer file.",
  restrictedDays: "Restricted Days",
  none: "None",
  callFrequency: "Call Frequency",
  restrictionLiftDate: "Restriction Lift Date",
};

type Props = {
  options: GetPhoneOptionsResponse;
  restriction: PhoneContact["restriction"];
  className?: string;
};

export default function ViewPhoneRestriction({
  restriction,
  options,
  className,
}: Props) {
  const isRestricted = restriction !== null;

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={classNames(
          styles.statusLine,
          !isRestricted ? styles.notRestrictedStatusLine : undefined,
        )}
      >
        <span>
          {isRestricted ? strings.restrictedUseYes : strings.restrictedUseNo}
        </span>
        <Tooltip>
          <p className={styles.tooltip}>{strings.tooltipText}</p>
        </Tooltip>
      </div>
      {isRestricted && (
        <div className={styles.content}>
          <LabeledInfo
            label={strings.restrictedDays}
            value={
              restriction.restrictionDays.length > 0
                ? restriction.restrictionDays
                    .map(
                      (d) =>
                        options.restrictionDays.find((o) => o.id === d)?.value,
                    )
                    .join(", ")
                : strings.none
            }
            orientation="vertical"
          />
          <LabeledInfo
            label={strings.callFrequency}
            value={
              options.restrictionFrequencies.find(
                (rf) => rf.id === restriction.restrictionFrequency,
              )?.value ?? "UNKNOWN"
            }
            orientation="vertical"
          />
          <LabeledInfo
            label={strings.restrictionLiftDate}
            value={
              restriction.restrictionLiftDate
                ? formatInCentralTime(
                    restriction.restrictionLiftDate,
                    "MM/dd/yyyy",
                  )
                : strings.none
            }
            orientation="vertical"
          />
        </div>
      )}
    </div>
  );
}
